import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static get targets() {
    return [
      "title",
      "description",
      "suggestQuestionButton",
      "questionKey",
      "addQuestion",
      "panelId",
      "skillCategory",
      "skillSubcategory",
      "skillCategoryTier3",
      "supplierSkill"
    ];
  }

  static outlets = ["tiptap"];

  connect() {
    this.showHideButton();
    this.targetPresenceListener();
    this.pluralitySuggestionButton();
    this.observeTargetList();
  }

  observeTargetList() {
    if (!this.hasAddQuestionTarget) {
      return;
    }
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        this.pluralitySuggestionButton();
      });
    });

    observer.observe(this.addQuestionTarget, { childList: true, subtree: true });
  }


  pluralitySuggestionButton() {
    if (!this.hasSuggestQuestionButtonTarget) {
      return;
    }
    const icon = document.createElement("i");
    icon.className = "fa fa-magic";
    if (this.questionKeyTargets.length > 0) {
      this.suggestQuestionButtonTarget.textContent = "";
      this.suggestQuestionButtonTarget.appendChild(icon);
      this.suggestQuestionButtonTarget.append(window.I18n["jobs.form.job_screening_questions.suggest_single"]);
    } else {
      this.suggestQuestionButtonTarget.textContent = "";
      this.suggestQuestionButtonTarget.appendChild(icon);
      this.suggestQuestionButtonTarget.append(window.I18n["jobs.form.job_screening_questions.suggest_multiple"]);
    }
    this.suggestQuestionButtonTarget.parentElement.children[1].classList.add("hide");
  }

  showHideButton() {
    if (!this.hasSuggestQuestionButtonTarget) {
      return;
    }
    let descriptionText;
    if (this.hasTiptapOutlet && this.tiptapOutlet.editor) {
      descriptionText = this.tiptapOutlet.editor.getText();
    } else if (this.hasDescriptionTarget) {
      descriptionText = this.descriptionTarget.value;
    } else {
      descriptionText = '';
    }

    if (this.titleTarget.value && descriptionText.trim().length > 0) {
      this.suggestQuestionButtonTarget.removeAttribute("onclick");
      this.suggestQuestionButtonTarget.removeAttribute("data-toggle");
      this.suggestQuestionButtonTarget.setAttribute("data-original-title", window.I18n["jobs.form.job_screening_questions.suggest_hint"]);
      this.suggestQuestionButtonTarget.removeAttribute("style");
    } else {
      this.suggestQuestionButtonTarget.setAttribute("onclick", "return false;");
      this.suggestQuestionButtonTarget.setAttribute("data-toggle", "tooltip");
      this.suggestQuestionButtonTarget.setAttribute("data-original-title", window.I18n["jobs.form.job_screening_questions.tooltip"]);
      this.suggestQuestionButtonTarget.setAttribute("style", "color: gray;");
    }
  }

  targetPresenceListener() {
    this.titleTarget.addEventListener("input", () => {
      this.showHideButton();
    });

    if (this.hasTiptapOutlet) {
      this.tiptapOutlet.element.addEventListener("tiptap:ready", () => {
        this.editor = this.tiptapOutlet.editor;
        this.editor.on("update", () => {
          this.showHideButton();
        });
        this.showHideButton();
      });
    } else if (this.hasDescriptionTarget) {
      this.descriptionTarget.addEventListener("input", () => {
        this.showHideButton();
      });
    }
  }


  sendRequest(e) {
    e.preventDefault();
    const payload = this.gatherJobData();
    if (payload.title && payload.description) {
      this.suggestQuestionButtonTarget.textContent = window.I18n["jobs.form.job_screening_questions.loading"];
      this.suggestQuestionButtonTarget.parentElement.children[1].classList.remove("hide");
      var headers = {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken()
      };
      fetch("/screening_questions/suggest", {
        method: "POST",
        credentials: "same-origin",
        headers,
        body: JSON.stringify(payload)
      })
        .then((response) => response.text());
    }
  }

  metaValue(name) {
    const element = document.head.querySelector(`meta[name="${name}"]`);
    return element && element.getAttribute("content");
  }


  csrfToken() {
    return this.metaValue("csrf-token");
  }

  gatherJobData() {
    let descriptionText;
    if (this.hasTiptapOutlet && this.tiptapOutlet.editor) {
      descriptionText = this.tiptapOutlet.editor.getText();
    } else if (this.hasDescriptionTarget) {
      descriptionText = this.descriptionTarget.value;
    } else {
      descriptionText = '';
    }
    const cleanedDescription = descriptionText.replace(/<\/?p>/g, "");
    const questionKeys = [];
    this.questionKeyTargets.forEach((element) => {
      questionKeys.push(element.value);
    });
    const payload = {
      title: this.titleTarget.value,
      description: cleanedDescription,
      skillCategory: this.skillCategoryTarget.value,
      skillSubcategory: this.skillSubcategoryTarget.value,
      skillCategoryTier3: this.hasSkillCategoryTier3Target ? this.skillCategoryTier3Target.value : '',
      supplierSkill: this.supplierSkillTarget.value,
      count: questionKeys.length,
      questionKeys,
      panelId: this.panelIdTarget.id
    };
    if (this.suggestQuestionButtonTarget.getAttribute("data-job-persisted") === "true") {
      const jobId = this.suggestQuestionButtonTarget.getAttribute("data-job-id");
      payload.jobId = jobId;
      return payload;
    }
    return payload;
  }
}